import { useEffect, useState } from "react";
import "../../styles/style.css";
import HeaderBar from "./HeaderBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import { useData } from "./MemberData";
import Cookies from "js-cookie";
import axios from "axios";
import { Modal, Backdrop, Fade, Box } from "@mui/material";
import { useTheme } from "./ThemeContext";

interface Bonus {
  callsign: number;
  pilot: number;
  moto: number;
  admitere: number;
  adeverinte: number;
  smuls: number;
  tatuaje: number;
  faciala: number;
  hr: number;
  pr: number;
  cj: number;
  mmls: number;
  addedBonus: number;
  conducereStatus: Boolean;
  testerStatus: Boolean;
  opStatus: Boolean;
  mmlsStatus: Boolean;
}

function BonusPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const [bonusData, setBonusData] = useState<Bonus[]>([]);
  const { membersData, getMemberInfo, getDiscordMemberInfo } = useData();
  const [isConducere, setIsConducere] = useState(false);
  const { theme } = useTheme();
  const [myDiscordID, setMyDiscordID] = useState("");

  const [userCallsign, setUserCallsign] = useState("");
  const [OpenBonusModal, setOpenBonusModal] = useState(false);
  const [bonusGestionOpen, setBonusGestionOpen] = useState(false);
  const [addedBonus, setAddedBonus] = useState("");
  const [toAddBonusCallsign, setAddCallsign] = useState(0);

  const [pilotBonus, setPilotBonus] = useState("");
  const [motoBonus, setMotoBonus] = useState("");
  const [admitereBonus, setAdmitereBonus] = useState("");
  const [adeverinteBonus, setAdeverinteBonus] = useState("");
  const [smulsBonus, setSmulsBonus] = useState("");
  const [tatuajeBonus, setTatuajeBonus] = useState("");
  const [facialaBonus, setFacialaBonus] = useState("");
  const [mmlsBonus, setMmlsBonus] = useState("");

  useEffect(() => {
    let isConducereTemp = false;
    setMyDiscordID(Cookies.get("myDiscordID") || "");

    for (let index = 0; index < membersData.length; index++) {
      const member = membersData[index];
      if (
        member.discordID === myDiscordID &&
        (member.grade === "Director-General" ||
          member.grade === "Director-Adjunct" ||
          member.grade === "Medic-Inspector" ||
          member.grade === "Medic-Chirurg")
      ) {
        isConducereTemp = true;
      }
    }
    getBonusMembersData();
    setIsConducere(isConducereTemp);
  }, [membersData, myDiscordID]);

  const handleTokenRefresh = async () => {
    try {
        let refreshToken = Cookies.get("refreshToken");
        const response = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
            refreshToken: refreshToken
        });

        if (response.statusText === "OK") {
            const newAccessToken = response.data.accessToken;
            Cookies.set("accessToken", newAccessToken, { expires: 7 });
        } else {
            toast.error("Nu am putut reînnoi tokenul! Te rog să te loghezi din nou.");
        }
    } catch (err) {
        toast.error("Eroare la reînnoirea tokenului. Te rog să te loghezi din nou.");
    }
  };

  const getBonusMembersData = async () => {
    try {
      const response = await axios.get("http://panelmedici.fplayt.ro:5000/bonus/get");
      if (response && response.data) {
        setBonusData(response.data);
      } else {
        toast.error("A aparut o eroare! Bonusurile nu au fost incarcate.");
        return;
      }
    } catch (err) {
      toast.error("A aparut o eroare! Bonusurile nu au fost incarcate.");
    }
  };

  const handleOpenBonusModal = () => {
    setOpenBonusModal(true);
  };

  const handleBonusModalClose = () => {
    setUserCallsign("");
    setOpenBonusModal(false);
  };

  const calculeazaBonus = async () => {
    try {
      let token = Cookies.get("accessToken");
      await axios.post("http://panelmedici.fplayt.ro:5000/bonus/calculeazaBonus", {
        callsign: Number(userCallsign) || 0,
        pilot: Number(pilotBonus) || 0,
        moto: Number(motoBonus) || 0,
        admitere: Number(admitereBonus) || 0,
        adeverinte: Number(adeverinteBonus) || 0,
        smuls: Number(smulsBonus) || 0,
        tatuaje: Number(tatuajeBonus) || 0,
        faciala: Number(facialaBonus) || 0,
        mmls: Number(mmlsBonus) || 0,
      }, { headers: { Authorization: `Bearer ${token}` } });
      
      toast.success("Bonusurile au fost calculate cu succes!");
      handleBonusModalClose();
    } catch (err) {
      if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
        await handleTokenRefresh();
        await calculeazaBonus();
      } else {
        console.log(err);
        toast.error("A aparut o eroare! Bonusurile nu au fost calculate!");
      }
    }
  };

  const payBonus = async (callsign: number, tip: string) => {
    try {
      const response = await axios.get(
        `http://panelmedici.fplayt.ro:5000/bonus/getByCS?callsign=${callsign}`
      );
      if (response && response.data) {
        if (tip === "conducere") {
          let token = Cookies.get("accessToken")
          const updateResponse = await axios.post(
            "http://panelmedici.fplayt.ro:5000/bonus/setPaid",
            {
              callsign: callsign,
              type: "conducere",
              status: !Boolean(response.data[0].conducereStatus),
            }, { headers: { Authorization: `Bearer ${token}` } }
          );
          if (updateResponse.statusText !== "OK") {
            toast.error(
              "A aparut o eroare! Bonusul nu a fost setat ca PLATIT!"
            );
            getBonusMembersData();
          } else {
            toast.info("Bonus setat cu succes!");
          }
        } else if (tip === "tester") {
          let token = Cookies.get("accessToken")
          const updateResponse = await axios.post(
            "http://panelmedici.fplayt.ro:5000/bonus/setPaid",
            {
              callsign: callsign,
              type: "tester",
              status: !Boolean(response.data[0].testerStatus),
            }, { headers: { Authorization: `Bearer ${token}` } }
          );
          if (updateResponse.statusText !== "OK") {
            toast.error(
              "A aparut o eroare! Bonusul nu a fost setat ca PLATIT!"
            );
            getBonusMembersData();
          } else {
            toast.info("Bonus setat cu succes!");
          }
        } else if (tip === "op") {
          let token = Cookies.get("accessToken")
          const updateResponse = await axios.post(
            "http://panelmedici.fplayt.ro:5000/bonus/setPaid",
            {
              callsign: callsign,
              type: "operatie",
              status: !Boolean(response.data[0].opStatus),
            }, { headers: { Authorization: `Bearer ${token}` } }
          );
          if (updateResponse.statusText !== "OK") {
            toast.error(
              "A aparut o eroare! Bonusul nu a fost setat ca PLATIT!"
            );
            getBonusMembersData();
          } else {
            toast.info("Bonus setat cu succes!");
          }
        } else if (tip === "mmls") {
          let token = Cookies.get("accessToken")
          const updateResponse = await axios.post(
            "http://panelmedici.fplayt.ro:5000/bonus/setPaid",
            {
              callsign: callsign,
              type: "mmls",
              status: !Boolean(response.data[0].mmlsStatus),
            }, { headers: { Authorization: `Bearer ${token}` } }
          );
          if (updateResponse.statusText !== "OK") {
            toast.error(
              "A aparut o eroare! Bonusul nu a fost setat ca PLATIT!"
            );
            getBonusMembersData();
          } else {
            handleBonusModalClose();
            toast.info("Bonus setat cu succes!");
          }
        }
      }
    } catch (err) {
      console.log(err);
      toast.error("A aparut o eroare! Bonusul nu a fost platit!");
    }
    getBonusMembersData();
  };

  const filteredMembers = bonusData
    .filter((member) => {
      const searchLower = searchTerm.toLowerCase();
      const fullName = getMemberInfo(member.callsign, "full_name") || "";
      const userId = getMemberInfo(member.callsign, "user_id") || "";

      return (
        fullName.toLowerCase().includes(searchLower) ||
        String(member.callsign).padStart(3, "0").includes(searchLower) ||
        String(userId).includes(searchLower)
      );
    })
    .sort((a, b) => a.callsign - b.callsign);

  const conducereMembers = filteredMembers.filter((member) => {
    const rank = getMemberInfo(member.callsign, "grade") || "";
    return [
      "Director-General",
      "Director-Adjunct",
      "Medic-Inspector",
      "Medic-Chirurg",
    ].includes(rank);
  });

  const testerMembers = filteredMembers.filter((member) => {
    return member.callsign > 100 && member.callsign < 300;
  });

  const operatiiMembers = filteredMembers.filter((member) => {
    return member.callsign > 100 && member.callsign < 400;
  });

  const mmlsMembers = filteredMembers.filter((member) => {
    return getMemberInfo(member.callsign, "functions")?.["M.M.L.S"] === true;
  });

  const bonusStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "35%",
    height: "75%",
    display: "flex",
    flexDirection: "column",
    gap: "2%",
    bgcolor: theme === "dark" ? "#191919" : "white",
    boxShadow: 24,
    borderRadius: ".3vw",
    outline: "none",
    p: 2,
  };

  const bonus2style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '25%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: theme === 'dark' ? '#191919' : 'white',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
}

  const handleBonusGestOpen = (callsign: number) => {
    setAddCallsign(callsign);    
    setBonusGestionOpen(true);    
  }

  const handleBonusGestionClose = () => {
    setBonusGestionOpen(false);
  }

  const salveazaBonus = async () => {
    if (Number(addedBonus) >= 0) {
      if (getMemberInfo(toAddBonusCallsign, "discordID")) {
        let token = Cookies.get("accessToken");
        try {
          await axios.post(
            "http://panelmedici.fplayt.ro:5000/bonus/addedBonus",
            {
              callsign: toAddBonusCallsign,
              addedBonus: Number(addedBonus) || 0
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setAddedBonus("");
          setAddCallsign(0);
          setBonusGestionOpen(false);
          toast.success("Bonusul a fost adaugat cu succes!");
        } catch (err) {
          console.log(err);
          if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
            await handleTokenRefresh();
            await salveazaBonus();
          } else {
            toast.error("A aparut o eroare! Bonusul nu a fost salvat!");
            return;
          }
        }
      } else {
        toast.error("Callsign invalid!");
      }
    } else {
      toast.error("Suma introdusa nu este valida!");
    }
  };

  return (
    <div className="w-full h-full flex flex-col">
      <HeaderBar currentPage="Bonusuri" />
      <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
        <div className="w-full h-[7%] flex items-center justify-between">
          <span className="textSemiBold text-[1.1vw] text-[#000000] dark:text-[#ffffff]">
            Bonusuri Departament
          </span>
          {(isConducere || (getDiscordMemberInfo(myDiscordID, "grade") === "Responsabil-Panel")) && (
            <div className="w-[60%] h-full flex items-center justify-center gap-[1%]">
              <div
                onClick={handleOpenBonusModal}
                className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]"
              >
                <span className="textBold text-white text-[.8vw]">
                  CALCULEAZA BONUSURI
                </span>
              </div>
            </div>
          )}
          <div className="bg-[#00000010] dark:bg-[#ffffff10] border border-[#00000020] dark:border-[#ffffff20] w-[15%] h-[90%] rounded-full flex items-center justify-between box-border px-[1%]">
            <input
              type="text"
              placeholder="Caută un medic"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pb-[1%] text-[#00000050] dark:text-[#ffffff50] dark:placeholder-[#ffffff50] placeholder-[#00000050] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent h-full border-none outline-none"
            />
            <FontAwesomeIcon
              className="text-[#00000050] dark:text-[#ffffff50] text-[0.8vw]"
              icon={faMagnifyingGlass}
            />
          </div>
        </div>
        <div className="bg-white dark:bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
          <div className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-b-[3px] border-[#D0D0D0]">
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[3%]">
              ID
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[3.5%]">
              CS
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[10%]">
              NUME
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[7%]">
              PILOT
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[7%]">
              MOTO
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[7%]">
              ADMITERE
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[7%]">
              ADEVERINTE
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[7%]">
              SMULS
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[6%]">
              TOTAL
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[6%]">
              INCASAT
            </span>
            {(isConducere || getDiscordMemberInfo(myDiscordID, "grade") === "Responsabil-Panel") && (
              <>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-black dark:text-white text-[1vw] w-[13.5%]">GESTIUNE</span>
              </>
            )}
          </div>
          {conducereMembers.map((member) => (
            <div
              key={member.callsign}
              className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
            >
              <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {getMemberInfo(member.callsign, "user_id")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                M-{String(member.callsign).padStart(3, "0")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[10%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {getMemberInfo(member.callsign, "full_name")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.pilot}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.moto}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.admitere}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.adeverinte}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.smuls}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[6%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                <span className="text-green-500">500,000</span>
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              {Boolean(member.conducereStatus) === false ? (
                (isConducere ? (
                  <div onClick={() => payBonus(member.callsign, "conducere")} className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                      <span className="textBold text-white text-[.7vw]">NEINCASAT</span>
                  </div>
                ) : (
                    <div className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                        <span className="textBold text-white text-[.7vw]">NEINCASAT</span>
                    </div>
                ))
              ) : (
                (isConducere ? (
                  <div onClick={() => payBonus(member.callsign, "conducere")} className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#2ad80f] to-[#18f518]">
                    <span className="textBold text-white text-[.7vw]">INCASAT</span>
                  </div>
                ) : (
                  <div className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#2ad80f] to-[#18f518]">
                    <span className="textBold text-white text-[.7vw]">INCASAT</span>
                  </div>
                ))
              )}
            </div>
          ))}
          <div className="w-full min-h-[7%] flex items-center justify-center border-b-[1px] border-[#D0D0D0]">
            <span className="textBold text-center text-black dark:text-white text-[1vw]">
              TESTERI
            </span>
          </div>
          {testerMembers.map((member) => (
            <div
              key={member.callsign}
              className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
            >
              <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {getMemberInfo(member.callsign, "user_id")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                M-{String(member.callsign).padStart(3, "0")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[10%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {getMemberInfo(member.callsign, "full_name")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.pilot}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.moto}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.admitere}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.adeverinte}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.smuls}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[6%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]"><span className='text-green-500'>{((member.pilot*20000 + member.moto*15000 + member.admitere*20000 + member.adeverinte*5000 + member.smuls*20000)+member.addedBonus).toLocaleString('en-US')}</span></span>
              {/* <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <div className="w-[13.5%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                                <span className="textBold text-white text-[.7vw]">GESTIONEAZA</span>
                            </div> */}
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              {Boolean(member.testerStatus) === false ? (
                (isConducere ? (
                  <div onClick={() => payBonus(member.callsign, "tester")} className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                      <span className="textBold text-white text-[.7vw]">NEINCASAT</span>
                  </div>
                ) : (
                    <div className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                        <span className="textBold text-white text-[.7vw]">NEINCASAT</span>
                    </div>
                ))
              ) : (
                (isConducere ? (
                  <div onClick={() => payBonus(member.callsign, "tester")} className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#2ad80f] to-[#18f518]">
                      <span className="textBold text-white text-[.7vw]">INCASAT</span>
                  </div>
                ) : (
                    <div className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#2ad80f] to-[#18f518]">
                        <span className="textBold text-white text-[.7vw]">INCASAT</span>
                    </div>
                ))
              )}
              {(isConducere || getDiscordMemberInfo(myDiscordID, "grade") === "Responsabil-Panel") && (
                <>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                  <div onClick={() => handleBonusGestOpen(member.callsign)} className="w-[13.5%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                    <span className="textBold text-white text-[.7vw]">GESTIONEAZA</span>
                  </div>
                </>
              )}
            </div>
          ))}
          <div className="w-full min-h-[7%] flex items-center justify-center">
            <span className="textBold text-center text-black dark:text-white text-[1vw]">
              OPERATII TATUAJE/FACIALE
            </span>
          </div>
          <div className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-t-[3px] border-b-[3px] border-[#D0D0D0]">
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[3%]">
              ID
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[3.5%]">
              CS
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[10%]">
              NUME
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[7%]">
              OPERATII TATUAJE
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[7%]">
              OPERATII FACIALE
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[7%]">
              TOTAL OP
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[6%]">
              TOTAL
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[6%]">
              INCASAT
            </span>
            {(isConducere || getDiscordMemberInfo(myDiscordID, "grade") === "Responsabil-Panel") && (
              <>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-black dark:text-white text-[1vw] w-[13.5%]">GESTIUNE</span>
              </>
            )}
          </div>
          {operatiiMembers.map((member) => (
            <div
              key={member.callsign}
              className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
            >
              <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {getMemberInfo(member.callsign, "user_id")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                M-{String(member.callsign).padStart(3, "0")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[10%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {getMemberInfo(member.callsign, "full_name")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.tatuaje}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.faciala}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.tatuaje + member.faciala}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[6%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                <span className="text-green-500">
                  {(
                    member.tatuaje * 2000 +
                    member.faciala * 30000
                  ).toLocaleString("en-US")}
                </span>
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              {Boolean(member.opStatus) === false ? (
                (isConducere ? (
                    <div onClick={() => payBonus(member.callsign, "op")} className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                        <span className="textBold text-white text-[.7vw]">NEINCASAT</span>
                    </div>
                ) : (
                    <div className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                        <span className="textBold text-white text-[.7vw]">NEINCASAT</span>
                    </div>
                ))
              ) : (
                (isConducere ? (
                  <div onClick={() => payBonus(member.callsign, "op")} className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#2ad80f] to-[#18f518]">
                      <span className="textBold text-white text-[.7vw]">INCASAT</span>
                  </div>
                ) : (
                    <div className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#2ad80f] to-[#18f518]">
                        <span className="textBold text-white text-[.7vw]">INCASAT</span>
                    </div>
                ))
              )}
              {(isConducere || getDiscordMemberInfo(myDiscordID, "grade") === "Responsabil-Panel") && (
                <>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                  <div onClick={() => handleBonusGestOpen(member.callsign)} className="w-[13.5%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                      <span className="textBold text-white text-[.7vw]">GESTIONEAZA</span>
                  </div>
                </>
              )}
            </div>
          ))}
          <div className="w-full min-h-[7%] flex items-center justify-center">
            <span className="textBold text-center text-black dark:text-white text-[1vw]">
              M.M.L.S
            </span>
          </div>
          <div className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-t-[3px] border-b-[3px] border-[#D0D0D0]">
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[3%]">
              ID
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[3.5%]">
              CS
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[10%]">
              NUME
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[7%]">
              TOTAL CONTROALE
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[6%]">
              TOTAL
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-black dark:text-white text-[1vw] w-[6%]">
              INCASAT
            </span>
            {(isConducere || getDiscordMemberInfo(myDiscordID, "grade") === "Responsabil-Panel") && (
              <>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-black dark:text-white text-[1vw] w-[13.5%]">GESTIUNE</span>
              </>
            )}
          </div>
          {mmlsMembers.map((member) => (
            <div
              key={member.callsign}
              className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
            >
              <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {getMemberInfo(member.callsign, "user_id")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[3.5%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                M-{String(member.callsign).padStart(3, "0")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[10%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {getMemberInfo(member.callsign, "full_name")}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[7%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                {member.mmls}
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              <span className="textSemiBold w-[6%] text-center text-[#000000] text-[0.8vw] dark:text-[#ffffff]">
                <span className="text-green-500">
                  {(member.mmls * 7000).toLocaleString("en-US")}
                </span>
              </span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              {Boolean(member.mmlsStatus) === false ? (
                (isConducere ? (
                  <div onClick={() => payBonus(member.callsign, "mmls")} className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                      <span className="textBold text-white text-[.7vw]">NEINCASAT</span>
                  </div>
                ) : (
                    <div className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                        <span className="textBold text-white text-[.7vw]">NEINCASAT</span>
                    </div>
                ))
              ) : (
                (isConducere ? (
                  <div onClick={() => payBonus(member.callsign, "mmls")} className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#2ad80f] to-[#18f518]">
                      <span className="textBold text-white text-[.7vw]">INCASAT</span>
                  </div>
                ) : (
                    <div className="w-[6%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#2ad80f] to-[#18f518]">
                        <span className="textBold text-white text-[.7vw]">INCASAT</span>
                    </div>
                ))
              )}
            </div>
          ))}
        </div>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={OpenBonusModal}
        onClose={handleBonusModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={OpenBonusModal}>
          <Box sx={bonusStyle} className="flex flex-col items-center">
            <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">
              BONUSURI
            </span>
            <input
              onChange={(e) => setUserCallsign(e.target.value)}
              placeholder="Introdu callsign (ex: 501)"
              type="text"
              className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
            />
            <input
              onChange={(e) => setPilotBonus(e.target.value)}
              placeholder="PILOT"
              type="text"
              className="w-[60%] h-[25%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
            />
            <input
              onChange={(e) => setMotoBonus(e.target.value)}
              placeholder="MOTO"
              type="text"
              className="w-[60%] h-[25%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
            />
            <input
              onChange={(e) => setAdmitereBonus(e.target.value)}
              placeholder="ADMITERE"
              type="text"
              className="w-[60%] h-[25%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
            />
            <input
              onChange={(e) => setAdeverinteBonus(e.target.value)}
              placeholder="ADEVERINTE"
              type="text"
              className="w-[60%] h-[25%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
            />
            <input
              onChange={(e) => setSmulsBonus(e.target.value)}
              placeholder="SMULS"
              type="text"
              className="w-[60%] h-[25%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
            />
            <input
              onChange={(e) => setTatuajeBonus(e.target.value)}
              placeholder="TATUAJE"
              type="text"
              className="w-[60%] h-[25%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
            />
            <input
              onChange={(e) => setFacialaBonus(e.target.value)}
              placeholder="FACIALA"
              type="text"
              className="w-[60%] h-[25%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
            />
            <input
              onChange={(e) => setMmlsBonus(e.target.value)}
              placeholder="MMLS"
              type="text"
              className="w-[60%] h-[25%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
            />
            <div
              onClick={calculeazaBonus}
              className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]"
            >
              <span className="text-white textBold text-[1.1vw]">
                CALCULEAZA BONUS
              </span>
            </div>
          </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={bonusGestionOpen}
        onClose={handleBonusGestionClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
        backdrop: {
            timeout: 500,
        },
        }}
      >
        <Fade in={bonusGestionOpen}>
        <Box sx={bonus2style} className="flex flex-col items-center">
        <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">BONUSURI</span>
        <input
          onChange={e => setAddedBonus(e.target.value)}
          placeholder="Adauga suma la bonus"
          type="text"
          className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
        />
        <div onClick={salveazaBonus} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
          <span className="text-white textBold text-[1.1vw]">SALVEAZA BONUS</span>
        </div>
        </Box>
        </Fade>
      </Modal>
      <ToastContainer />
    </div>
  );
}

export default BonusPage;
